/*
 * The app's icons: one set, drawn for it on a 24 grid with round 1.75 strokes, so every icon matches.
 */
const PATHS = {
  home: "M4 10.5 12 4l8 6.5V19a1 1 0 0 1-1 1h-4.5v-5.5h-5V20H5a1 1 0 0 1-1-1z",
  schedule: "M4.5 6.5h15v13h-15zM4.5 10.5h15M8.5 4v4M15.5 4v4M8 14h2M12 14h2M8 17h2",
  requests:
    "M4.5 13.5 6.8 6.2a1 1 0 0 1 1-.7h8.4a1 1 0 0 1 1 .7l2.3 7.3V18a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1zM4.5 13.5H9l1 2h4l1-2h4.5",
  quotes: "M7 3.5h7l4.5 4.5v12a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5zM13.5 3.5V8.5h5M9.5 12.5h5M9.5 16h5",
  jobs: "M4 8.5h16v10.5H4zM9 8.5V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2.5M4 13h16",
  invoices: "M6 3.5h12v17l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5-2 1.5zM9 8.5h6M9 12h6M9 15.5h3.5",
  clients: "M12 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM5 20c.6-3.6 3.4-6 7-6s6.4 2.4 7 6",
  pipeline: "M4 5.5h16l-6 7.5v5.5l-4 1.5v-7z",
  marketing: "M4.5 10v4a1 1 0 0 0 1 1H8l6 4.5v-15L8 9H5.5a1 1 0 0 0-1 1zM17.5 9a4 4 0 0 1 0 6",
  payments: "M3.5 6.5h17v11h-17zM3.5 10h17M7 14.5h3",
  books: "M5 5a1.5 1.5 0 0 1 1.5-1.5H19v14H6.5A1.5 1.5 0 0 0 5 19zM5 19a1.5 1.5 0 0 0 1.5 1.5H19M9 7.5h6",
  team: "M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM3.5 19c.5-3 2.6-5 5.5-5s5 2 5.5 5M16 11a2.5 2.5 0 1 0 0-5M17.5 14c1.7.6 2.7 2.4 3 5",
  insights: "M4.5 19.5h15M7 16v-4M11 16V8M15 16v-6M19 16V5",
  settings:
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 13.5l1.4 1.1-1.6 2.8-1.7-.6a7 7 0 0 1-1.7 1l-.3 1.7h-3.2l-.3-1.7a7 7 0 0 1-1.7-1l-1.7.6-1.6-2.8 1.4-1.1a7 7 0 0 1 0-2l-1.4-1.1 1.6-2.8 1.7.6a7 7 0 0 1 1.7-1l.3-1.7h3.2l.3 1.7a7 7 0 0 1 1.7 1l1.7-.6 1.6 2.8-1.4 1.1a7 7 0 0 1 0 2z",
  search: "M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zM15.5 15.5 20 20",
  bell: "M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0",
  message: "M4.5 6.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H10l-4 3.5v-3.5h-.5a1 1 0 0 1-1-1z",
  plus: "M12 5v14M5 12h14",
  plusCircle: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 8.5v7M8.5 12h7",
  closeCircle: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM9.5 9.5l5 5M14.5 9.5l-5 5",
  chevronDown: "M7 10l5 5 5-5",
  chevronUp: "M7 14l5-5 5 5",
  sliders: "M4 7h9M17 7h3M4 17h3M11 17h9M15 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM9 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  chevronRight: "M10 7l5 5-5 5",
  more: "M6 12h.01M12 12h.01M18 12h.01",
  check: "M5.5 12.5l4 4 9-9",
  close: "M6.5 6.5l11 11M17.5 6.5l-11 11",
  menu: "M4.5 7h15M4.5 12h15M4.5 17h15",
  lock: "M6.5 10.5h11v9.5h-11zM8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5",
  key: "M14.5 13a4.5 4.5 0 1 0-4.1-6.3A4.5 4.5 0 0 0 10 8.5L3.5 15v3.5H7V16h2.5v-2.5H12l1-1",
  shield: "M12 3.5l7 2.5v5.5c0 4.3-2.9 7.6-7 9-4.1-1.4-7-4.7-7-9V6z M9 12l2 2 4-4",
  phone: "M7 3.5h10v17H7zM11 17.5h2",
  building: "M5 20.5V5.5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v15M15 10h3a1 1 0 0 1 1 1v9.5M3.5 20.5h17M8.5 8h3M8.5 11.5h3M8.5 15h3",
  info: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 11v5M12 8h.01",
  warning: "M12 4.5 3.5 19h17zM12 10v4M12 16.5h.01",
  activity: "M3.5 12h4l2.5-6 4 12 2.5-6h4",
  pin: "M12 20.5s6.5-5.6 6.5-10.5a6.5 6.5 0 0 0-13 0c0 4.9 6.5 10.5 6.5 10.5zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
  clock: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 8v4.5l3 2",
  signout: "M14 5.5h4.5v13H14M10 8l-4 4 4 4M6 12h9",
  sun: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 2.5v2M12 19.5v2M4.6 4.6l1.4 1.4M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4",
  moon: "M19 14.5A7.5 7.5 0 0 1 9.5 5a7.5 7.5 0 1 0 9.5 9.5z",
  mail: "M4 6.5h16v11H4zM4 7l8 6 8-6",
  hammer: "M14 4l6 6-2 2-6-6zM12 6l-8.5 8.5 3 3L15 9",
  truck: "M3 6.5h11v10H3zM14 9.5h4l3 3.5v3.5h-7M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  directions: "M12 2.8l9.2 9.2-9.2 9.2-9.2-9.2zM9 14.5V12a1.5 1.5 0 0 1 1.5-1.5H15M13 8.5l2 2-2 2",
  chevronLeft: "M14 7l-5 5 5 5",
  arrowLeft: "M19 12H5M11 6l-6 6 6 6",
  arrowRight: "M5 12h14M13 6l6 6-6 6",
  arrowUpRight: "M7 17 17 7M9 7h8v8",
  camera: "M4 8.5h3.5L9 6h6l1.5 2.5H20V19H4zM12 16.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
  file: "M7 3.5h7l4.5 4.5v12.5h-11.5zM13.5 3.5V8.5h5",
  note: "M5 4.5h14v10l-5 5H5zM14 19.5v-5h5M8.5 9h7M8.5 12.5h4",
  merge: "M7 4v4.5a4 4 0 0 0 4 4h6M7 20v-7.5M14 9.5l3 3-3 3",
  play: "M8 5.5v13l10.5-6.5z",
  stop: "M7 7h10v10H7z",
  list: "M9 7h11M9 12h11M9 17h11M4.5 7h.01M4.5 12h.01M4.5 17h.01",
  week: "M4.5 6.5h15v13h-15zM4.5 10.5h15M9.5 10.5v9M14.5 10.5v9",
  day: "M4.5 6.5h15v13h-15zM4.5 10.5h15M8 14h8M8 17h5",
  month: "M4.5 6.5h15v13h-15zM4.5 10.5h15M4.5 15h15M9.5 10.5v9M14.5 10.5v9",
  tag: "M4 4.5h7.5l8.5 8.5-7 7-8.5-8.5zM8 8.5h.01",
  undo: "M9 7.5 5 11.5l4 4M5 11.5h9a5 5 0 0 1 0 10h-2",
  trash: "M5 7h14M10 7V5h4v2M6.5 7l1 12.5h9l1-12.5M10 11v5M14 11v5",
  edit: "M5 19l1-4L15.5 5.5l3 3L9 18zM13.5 7.5l3 3",
  person: "M12 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM5 20c.6-3.6 3.4-6 7-6s6.4 2.4 7 6",
  route:
    "M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM8 17h7.5a2.5 2.5 0 0 0 0-5h-7a2.5 2.5 0 0 1 0-5H16",
  grip: "M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01",
  repeat: "M5 11V9a3 3 0 0 1 3-3h10M15 3l3 3-3 3M19 13v2a3 3 0 0 1-3 3H6M9 21l-3-3 3-3",
  checklist: "M10 7h10M10 12h10M10 17h10M4 7l1.2 1.2L7.5 6M4 12l1.2 1.2L7.5 11M4 17l1.2 1.2L7.5 16",
  money: "M3.5 6.5h17v11h-17zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6.5 9.5h.01M17.5 14.5h.01",
  sparkle:
    "M11 3.5c.6 4.1 2.4 5.9 6.5 6.5-4.1.6-5.9 2.4-6.5 6.5-.6-4.1-2.4-5.9-6.5-6.5 4.1-.6 5.9-2.4 6.5-6.5zM18 14.5c.3 1.8 1 2.5 2.5 2.8-1.5.3-2.2 1-2.5 2.7-.3-1.7-1-2.4-2.5-2.7 1.5-.3 2.2-1 2.5-2.8z",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20, label }: { name: IconName; size?: number; label?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
